import { buildPlaceUrls, contract, getLegacyPlaceTypeFromPlaceId, getSeoNameRedirectionData, PlaceTypeEnum, } from '@aviv_price-pages/brand';
import HttpClient from '@/adapters/http/HttpClient';
import { appendEphemeralParam } from '@/helpers/ephemeral/ephemeral';
export async function seoNameRedirect(req, res) {
    const { pathname, search } = req.url;
    contract.redirects?.forEach((redirect) => {
        if (pathname === `${contract.basePath}${redirect.source}`) {
            return;
        }
    });
    const redirectionData = await getSeoNameRedirectionData(pathname);
    if (!redirectionData || !redirectionData.wl_location_id) {
        return;
    }
    const { path_seoname, output_seoname, primary, wl_location_id } = redirectionData;
    if (getLegacyPlaceTypeFromPlaceId(wl_location_id) === PlaceTypeEnum.STREET) {
        const httpClient = HttpClient.getInstance();
        const place = await httpClient.get(`${process.env.BFF_BASE_URL}/place?id=${wl_location_id}&locale=${contract.i18n.defaultLocale}`, undefined, process.env.BFF_API_KEY);
        if (!place) {
            return;
        }
        const urls = await buildPlaceUrls(contract.nameAbbreviation, [place], true);
        const url = urls[0];
        if (url) {
            const fullUrl = appendEphemeralParam(url + search);
            return res.redirect(fullUrl, 301);
        }
    }
    if (path_seoname !== output_seoname && primary) {
        const redirectUrl = `${contract.basePath}/${output_seoname}`;
        const fullUrl = appendEphemeralParam(redirectUrl + search);
        return res.redirect(fullUrl, 301);
    }
}
